const mFeedSectionContentCardDesign1 = {
  mFeedSectionContentCardDesign1: {
    products: 'Nuevo Producto',
    projects: 'Nueva Formación'
  }
}

export default mFeedSectionContentCardDesign1
